import styled from 'styled-components';

import { MenuItemType } from '../headerTypes';

// const DividerVertical = styled.div`
//   border-left: 1px solid var(--gray);

//   margin-top: 15px;
//   margin-bottom: 15px;
// `;

const DividerHorizontal = styled.div`
  border-bottom: 1px solid #2f2f34;
  width: 100%;
  height: 1px;
  padding-top: 8px;
  margin-bottom: 8px;
`;

const SpacerHorizontal = styled.div`
  height: 8px;
`;

const DividerMarginVertical = styled.div`
  margin-right: 10px;
`;

// export const DividerVerticalItem = {
//   Component: DividerVertical,
// };

export const DividerHorizontalItem: MenuItemType = {
  type: 'MenuBox',
  Component: DividerHorizontal,
};

export const HorizontalSpacerItem: MenuItemType = {
  type: 'MenuBox',
  Component: SpacerHorizontal,
};

export const DividerMarginVerticalItem: MenuItemType = {
  type: 'MenuBox',
  Component: DividerMarginVertical,
};
